// extracted by mini-css-extract-plugin
export var titleWrapper = "style-module--titleWrapper--AMH4V";
export var labelWrapper = "style-module--labelWrapper--jafdn";
export var label = "style-module--label--4kGyM";
export var optional = "style-module--optional--YKKky";
export var subTitle = "style-module--subTitle--G3N9D";
export var tooltipWrapper = "style-module--tooltipWrapper--lZ21E";